module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-group listerprets-dialogPopupRow">\r\n  <fieldset class="listerprets-dialogPopupRow cw-fieldset">\r\n    <div class="phx-formTable">\r\n    <div class="input-group">\r\n        <div class="phx-listerprets-data">\r\n          <label for="commentaire" class="cw-label-entrezcomment text-left" title="'+
((__t=(i18n.t("common:listerprets.commentaires")))==null?'':__t)+
'">'+
((__t=(UTILS.getSVGIcon('bulle','',16)))==null?'':__t)+
'  '+
((__t=(i18n.t("common:listerprets.commentaires")))==null?'':__t)+
'</label>\r\n          <textarea class="commentaire form-control" rows="6" cols="40" maxlength="200" style="resize:none"></textarea>\r\n          <!--Histo wkf component-->\r\n          <span class="listerprets-wkfhisto"></span>\r\n          <span class="buttons"></span>\r\n        </div>\r\n    </div>\r\n  </fieldset>\r\n</div>\r\n';
}
return __p;
};
